import axios, {AxiosError, InternalAxiosRequestConfig} from "axios";

export const publicApi = axios.create({
    baseURL: "/api/cr-order-manager",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json"
    }
});

export const privateApi = axios.create({
    baseURL: "/api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json"
    }
});

export const privateApiLongTimeout = axios.create({
    baseURL: "/api",
    timeout: 180000,
    headers: {
        "Content-Type": "application/json"
    }
});

interface RetryableRequestConfig
    extends InternalAxiosRequestConfig {
    _retry?: boolean;
}

const redirectToLogin = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    window.location.href = "/login";
};

[privateApi, privateApiLongTimeout].forEach(api => {
    api.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("accessToken");
            config.headers.Authorization = `${token}`;

            return config;
        }
    );

    api.interceptors.response.use(
        response => response,

        async (error: AxiosError) => {
            const originalRequest =
                error.config as RetryableRequestConfig;

            // First 401 → try refreshing
            if (
                error.response?.status === 401 &&
                !originalRequest._retry
            ) {
                originalRequest._retry = true;

                try {
                    const response = await publicApi.put(
                        "/v1/auth/token",
                        {
                            refreshToken:
                                localStorage.getItem("refreshToken")
                        }
                    );

                    localStorage.setItem(
                        "accessToken",
                        response.data.accessToken
                    );

                    localStorage.setItem(
                        "refreshToken",
                        response.data.refreshToken
                    );

                    originalRequest.headers.Authorization =
                        `Bearer ${response.data.accessToken}`;

                    return privateApi(originalRequest);

                } catch (refreshError) {
                    // Refresh failed → send to login
                    redirectToLogin();

                    return Promise.reject(refreshError);
                }
            }

            // Second 401 after retry → login
            if (
                error.response?.status === 401 &&
                originalRequest?._retry
            ) {
                redirectToLogin();
            }

            return Promise.reject(error);
        }
    );
})